import {
  Box,
  Button,
  IconButton,
  makeStyles,
  useTheme,
} from "@material-ui/core";
import React, { useEffect, forwardRef } from "react";
import { Delete } from "@material-ui/icons";
import MaterialTable from "material-table";
import { tableIcons } from "../../tableIcons";
import { useDispatch, useSelector } from "react-redux";
import { getMemberAdcards } from "../../../../redux-store/adCard/actions";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  root: {
    // width: '100%',
    border: `1px solid ${theme.palette.secondary.dark}`,
    borderRadius: "5px",
    marginTop: "30px",
    padding: "10px",
    [theme.breakpoints.down("md")]: {
      marginTop: "30px",
    },
  },
  tabHeading: {
    fontSize: "32px",
    fontWeight: 550,
    margin: "0",
  },
  userName: {
    color: theme.palette.primary.dark,
    fontSize: 22,
    fontWeight: 500,
  },
  subHead: {
    margin: 0,
    fontSize: 18,
    fontWeight: 550,
    width: "150px",
  },
  copyBtn: {
    backgroundColor: theme.palette.primary.dark,
    color: "white",
    width: 100,
    padding: 2,
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.light,
    },
  },
}));

function AdCards() {
  const classes = useStyles();
  const theme = useTheme();
  const { adcards } = useSelector((state) => state.adCards);
  const { currentUser } = useSelector((state) => state.auth);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMemberAdcards(currentUser._id));
  }, []);

  return (
    <div className={classes.root}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
      >
        <h2 className={classes.tabHeading}>My AdCards</h2>
      </Box>
      <MaterialTable
        icons={tableIcons}
        columns={[
          { title: "Book Id", field: "bookId" },
          { title: "Book Title", field: "bookTitle" },
          { title: "Created", field: "created" },
          { title: "Expiry", field: "expiry" },
          { title: "Ad Card", field: "shareable_link" },
        ]}
        options={{
          toolbar: false,
          actionsColumnIndex: -1,
          headerStyle: {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.secondary.light,
            fontWeight: 600,
            fontSize: 16,
          },
          rowStyle: {
            alignItems: "center",
          },
        }}
        localization={{
          header: {
            actions: "",
          },
        }}
        actions={[
          {
            icon: "copy",
            tooltip: "Copy Link",
          },
          // {
          //   icon: "delete",
          //   tooltip: "Delete",
          //   onClick: (event, rowData) => {
          //     console.log(rowData.book_title);
          //   },
          // },
        ]}
        components={{
          Action: (props) => {
            if (props.action.icon === "copy") {
              return (
                <CopyToClipboard
                  text={props.data.shareable_link}
                  onCopy={() => toast.success("Copied to Clipboard")}
                >
                  <Button className={classes.copyBtn} color="primary">
                    {props.action.tooltip}
                  </Button>
                </CopyToClipboard>
              );
            }
            // if (props.action.icon === "delete") {
            //   return (
            //     <IconButton>
            //       <Delete />
            //     </IconButton>
            //   );
            // }
          },
        }}
        data={adcards?.map((item, index) => {
          return {
            bookId: (
              <img src={item.book.book_cover} style={{ width: "100%" }}></img>
            ),
            bookTitle: item.book.book_title,
            created: new Date(item.date_created).toLocaleDateString(),
            expiry: new Date(item.expiry_date).toLocaleDateString(),
            shareable_link: item.shareable_link,
          };
        })}
      ></MaterialTable>
    </div>
  );
}

export default AdCards;
